import { useData, withDefault } from "@faedev/editor-utils";
import constants from "src/constants";
import getCookieByName from "src/functions/getCookieByName";
import validateAuthToken from "src/functions/validateAuthToken";

function getDataMerch(
  slug?: string | null | undefined,
  lang?: string | null | undefined,
  refresh?: boolean | null | undefined
) {
  const cookieOrderId = getCookieByName(`orderId`);
  const isAuthorized = validateAuthToken(
    getCookieByName(`auth-token`),
    cookieOrderId
      ? {
          "Cookie-Order-Id": cookieOrderId,
        }
      : null,
    true
  );

  return useData(
    () =>
      fetch(`${constants.Paths.apiUrl}/merches/${slug}`, {
        method: "GET",
        headers: isAuthorized,
      }).then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error("API Error");
        }
      }),
    {
      _locale: withDefault(lang, constants.Locales._default.lang),
      refresh: refresh,
    }
  );
}

export default getDataMerch;
